import { Fragment, useState } from "react";
import FilterButton from "./FilterButton/FilterButton";
import Icon from "../Icon/Icon";
import classes from "./FilterTab.module.scss";
import { useTranslation } from "react-i18next";

const FilterTab = ({ group, options, selectedOption, onChangeFilter }) => {
  const { t } = useTranslation();
  const [showList, setShowList] = useState(false);

  const toggleList = () => {
    setShowList((oldState) => !oldState);
  };

  return (
    <Fragment>
      <div className={classes.FilterTab}>
        {options.map((option) => {
          return (
            <FilterButton
              key={option}
              name={group}
              value={option}
              text={option}
              isChecked={selectedOption === option}
              onChanged={onChangeFilter}
            />
          );
        })}
      </div>
      <div className={classes.MobileFilterTab}>
        <div className={classes.SelectedOption}>
          <label htmlFor={selectedOption}>{t(selectedOption)}</label>
        </div>
        <div className={classes.FilterDropdown}>
          <button onClick={toggleList} className={classes.FilterDropdownHead}>
            {t("MORE")} <Icon name="chevron-down" height={1.6} width={1.6} />
          </button>
          {showList && (
            <ul className={classes.FilterDropdownList}>
              {options.map((option) => {
                return (
                  <li className={classes.FilterDropdownItem}>
                    <input
                      id={option}
                      type="radio"
                      name={option}
                      value={option}
                      checked={selectedOption === option}
                      onChange={() => onChangeFilter(option)}
                    />
                    <label htmlFor={option}>{t(option)}</label>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default FilterTab;
